import React, { Component } from 'react';
import zxcvbn from "zxcvbn";
import styled from "styled-components";
import { Check } from "@material-ui/icons";
import MuiButton from '@material-ui/core/Button';

const PasswordTitle = styled.p`
  font-size: 18px;
  font-weight: normal;
  margin-top: 16px;
  margin-bottom: 20px;
`;

const PasswordMessage = styled.li`
  font-size: 16px;
  font-weight: normal;
  color: ${p => p.valid ? "#25a225" : "#F25F5C"}
  text-indent: 10px;
  margin: 0 0 3px 0;
`;

const MatchMessage = styled.div`
  font-size: 16px;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 15px;
  font-weight: normal;
  color: #25a225;
  margin-left: 15px;
  text-align: left;
  align-items: center;
  font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, sans-serif;

  & > svg { font-size: 24px; }
`;

const MessageWrapper = styled.p`
  text-align: left;
  margin-top: 15px;
`;

const CheckboxWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 15px;
  align-items: unset;
`;

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-gap: 15px;
  align-items: center;
  margin: 20px 15px 0px 15px;
`;

const Button = styled(MuiButton)`
  && {
    text-transform: unset;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  &&:disabled {
    cursor: not-allowed;
    background-color: #00D27F !important;
    opacity: 0.5;
  }
`;

const passwordLabels = {
  0: 'Weak',
  1: 'Weak',
  2: 'Fair',
  3: 'Good',
  4: 'Strong'
}

export default class StrongPassword extends Component {
  state = {
    password: '',
    password_confirmation: '',
    passwordScore: 0,
    passwordStrength: 'Weak',
    confirmValid: false,
    lengthValid: false,
    upperValid: false,
    lowerValid: false,
    numberValid: false,
    strengthValid: false,
    hidePassword: true,
    formIncomplete: true,
  }

  validate = (password) => {
    const testedResult = zxcvbn(password);
    const passwordScore = testedResult.score;
    const passwordStrength = passwordLabels[passwordScore];

    const lengthValid = password.length >= 8;
    const upperValid = (password.match(/[A-Z]/g) || []).length >= 1;
    const lowerValid = (password.match(/[a-z]/g) || []).length >= 1;
    const numberValid = (password.match(/[0-9]/g) || []).length >= 1;
    const strengthValid = passwordScore >= 2;

    this.setState({
      password,
      passwordScore,
      passwordStrength,
      lengthValid,
      upperValid,
      lowerValid,
      numberValid,
      strengthValid
    })
  }

  match = (password_confirmation) => {
    const {
      password,
      passwordScore
    } = this.state;
    const confirmValid = (password_confirmation === password);
    const formIncomplete = (passwordScore >= 2 && confirmValid === true) ? false : true;

    this.setState({
      formIncomplete,
      password_confirmation,
      confirmValid,
    })
  }

  toggleShow = () => this.setState({ hidePassword: !this.state.hidePassword });
  handleChangePass = (event) => this.validate(event.target.value);
  handleChangeConfirm = (event) => this.match(event.target.value);
  handleFocus = () => this.setState({focused: true})
  handleBlur = () => this.setState({focused: false})

  render() {
    const {
      password,
      passwordScore,
      passwordStrength,
      confirmValid,
      lengthValid,
      upperValid,
      lowerValid,
      numberValid,
      strengthValid,
      formIncomplete,
      focused,
      hidePassword
    } = this.state;
    const {
      invite_token,
      terms_path,
      user_license_agreement_path,
      privacy_policy_path,
      signup
    } = this.props;
    const {
      handleFocus,
      handleBlur,
      handleChangePass,
      handleChangeConfirm,
      toggleShow
    } = this;

    return (
      <div className="password-strength-meter">

        <input size="40"
          name="user[password]"
          id="password_input"
          placeholder="Password (8 minimum)"
          className={`form-control height_40 padding_left open_sans`}
          onChange={handleChangePass}
          type={hidePassword ? "password" : "text"}
          autoComplete="off"
          onFocus={() => handleFocus()}
          onBlur={() => handleBlur()}
          required
        />

        {
          (focused || !hidePassword) &&
          <div>
            <div className="password_progress_wrapper">
              <progress
                className={`password-strength-meter-progress strength-${passwordStrength}`}
                value={passwordScore}
                max="4"
              />
              <span className="font_1_3em">
                { passwordStrength }
              </span>
            </div>
            <label className="password-strength-meter-label">
              <MessageWrapper>
                <PasswordTitle>Password must contain the following:</PasswordTitle>
                <PasswordMessage valid={lengthValid}>
                  Minimum 8 characters in length
                </PasswordMessage>
                <PasswordMessage valid={upperValid}>
                  Must contain an uppercase character
                </PasswordMessage>
                <PasswordMessage valid={lowerValid}>
                  Must contain a lowercase character
                </PasswordMessage>
                <PasswordMessage valid={numberValid}>
                  Must contain a number
                </PasswordMessage>
                <PasswordMessage valid={strengthValid}>
                  {`Must be "Fair" or stronger`}
                </PasswordMessage>
              </MessageWrapper>
            </label>
          </div>
        }

        <div className='space-10'></div>

        <input size="40"
          name="user[password_confirmation]"
          id="confirm_input"
          placeholder="Confirm Password (8 minimum)"
          className={`form-control height_40 padding_left open_sans`}
          onChange={handleChangeConfirm}
          type={hidePassword ? "password" : "text"}
          autoComplete="off"
          required
          onFocus={() => handleFocus()}
          onBlur={() => handleBlur()}
        />
        {
          password &&
          <GridWrapper>
            <CheckboxWrapper>
              <div className="hl_checkbox inline_block">
                <input
                  type="checkbox"
                  name="show_password"
                  id="show_password"
                  value="true"
                  className="hl_checkbox display_none"
                  checked={!hidePassword}
                />
                <label onMouseDown={toggleShow} htmlFor="show_password"></label>
              </div>
              <div className='text-left inline font_1_3em'>
                Show password
              </div>
            </CheckboxWrapper>
            <span />
            {
              confirmValid &&
              <MatchMessage>
                <Check />
                Passwords match
              </MatchMessage>
            }
          </GridWrapper>
        }
        {
          !invite_token && signup &&
          <div className="row">
            <div className="space-10"></div>
            <div className="col-xs-12">

              <div className="hl_checkbox inline_block margin_right">
                <input
                  type="checkbox"
                  name="teams"
                  id="teams"
                  value="true"
                  className="hl_checkbox display_none"
                />
                <label htmlFor="teams"></label>
              </div>
              <div className="text-left inline font_1_3em">I need to invite other team members.</div>
            </div>
          </div>
        }
        {
          signup &&
          <div className="row">
            <div className="space-10"></div>
            <div className="col-xs-12">
              <div className="hl_checkbox inline_block margin_right">
                <input
                  type="checkbox"
                  name="i_agree"
                  id="agree_checkbox"
                  value="true"
                  className="hl_checkbox"
                  required
                />
                <label id="agree_label" htmlFor="agree_checkbox"></label>
              </div>
              <div className="text-left inline font_1_3em">
                I agree to the
                <span>
                  {` `}
                  <a href={terms_path} target='blank'>free trial terms</a>
                  {`, `}
                </span>
                <span>
                  <a href={user_license_agreement_path} target='blank'>user agreement</a>
                  {`, and `}
                </span>
                <span>
                  <a href={privacy_policy_path} target='blank'>privacy policy</a>.
                </span>
              </div>
            </div>
          </div>
        }
        <div className='col-xs-10 col-xs-offset-1 text-center'>
          <Button className='btn btn-success'
            name='commit'
            disabled= {formIncomplete}
            type="submit"
          >
            { signup ? "Create Account" : "Update Password"}
          </Button>
        </div>
      </div>
    );
  }
}
